import { IProgressStep, IProgressStepAction } from "./progressStepReducer";

export function updateProgressSteps(steps: IProgressStep[]): IProgressStepAction {
    return {
        type: 'PROGRESS_STEP_UPDATE',
        payload: steps,
    }
}